import React, { useState } from 'react';
import { Card, Form, Input, InputNumber, Button, Space, message, Divider } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const VipProductConfig: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSave = async (values: any) => {
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 800));
      message.success('VIP商品配置已保存');
    } catch (error) {
      message.error('保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    message.info('已重置为默认配置');
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="VIP配置">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            monthTitle: '月度会员',
            monthPrice: 29,
            monthBenefits: '无广告观看\\n高清画质\\n抢先看新剧\\n专属客服',
            quarterTitle: '季度会员',
            quarterPrice: 79,
            quarterBenefits: '无广告观看\\n高清画质\\n抢先看新剧\\n专属客服\\n会员专享内容',
            yearTitle: '年度会员',
            yearPrice: 299,
            yearBenefits: '无广告观看\\n高清画质\\n抢先看新剧\\n专属客服\\n会员专享内容\\n年度专属特权',
          }}
        >
          <Card size="small" title="月付费商品" style={{ marginBottom: 16 }}>
            <Form.Item label="展示标题" name="monthTitle">
              <Input />
            </Form.Item>
            <Form.Item label="价格" name="monthPrice">
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="展示文本（每行一条）" name="monthBenefits">
              <TextArea rows={4} placeholder="无广告观看\n高清画质" />
            </Form.Item>
          </Card>

          <Card size="small" title="季度付费商品" style={{ marginBottom: 16 }}>
            <Form.Item label="展示标题" name="quarterTitle">
              <Input />
            </Form.Item>
            <Form.Item label="价格" name="quarterPrice">
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="展示文本（每行一条）" name="quarterBenefits">
              <TextArea rows={4} placeholder="无广告观看\n高清画质" />
            </Form.Item>
          </Card>

          <Card size="small" title="年付费商品" style={{ marginBottom: 16 }}>
            <Form.Item label="展示标题" name="yearTitle">
              <Input />
            </Form.Item>
            <Form.Item label="价格" name="yearPrice">
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="展示文本（每行一条）" name="yearBenefits">
              <TextArea rows={4} placeholder="无广告观看\n高清画质" />
            </Form.Item>
          </Card>

          <Divider />

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
                保存配置
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default VipProductConfig;







